<template>
  <section class="l-about">
    <scroll-spy ref="scrollSpy">
      <scroll-spy-section class="l-about__eyecatch js-navigation-switch" :label="`About Setouchi Cominca Stays`" :style="{
        height: eyecatchHeight
      }">
        <div class="js-scroll-animation-unit" ref="heading">
          <h2 class="l-about__heading">About<br>Setouchi Cominca Stays</h2>
        </div>
      </scroll-spy-section>
      
      <scroll-spy-section :label="`The Magic of the Seto Inland Sea`">
        <section class="p-about">
          <color-overlay class="p-about__header">
            <h3 class="p-about__heading"><span class="p-about__mask">The Magic of <br v-show="isMobile">the Seto Inland Sea</span></h3>
            <div class="p-about__visual js-navigation-switch">
              <div class="p-about__parallax js-rellax">
                <img src="../assets/img/about/section_1.jpg" alt="" class="u-cover">
              </div>
            </div>
          </color-overlay>
          
          <div class="p-about__body">
            <scroll-animation-unit 
              class="p-about__text">
              <p class="p-about__lead u-fade">Known to 19th century explorers as the Aegean of the East, the Setouchi region in western Japan bordering the beautiful Inland Sea is unlike other areas of the country. With its moderate climate, serene waters, charming people and fascinating history, the secrets of the Setouchi region await the intrepid traveler.</p>
            </scroll-animation-unit>
            <div>
              <scroll-animation-unit class="p-feature" data-flipped>
                <color-overlay class="p-feature__image" :scale="true">
                  <img src="../assets/img/about/islands.jpg" alt="" class="u-cover">
                  <img src="../assets/img/about/islands.jpg" alt="" class="u-cover p-feature__grayImage">
                </color-overlay>
                <dl class="p-feature__description">
                  <dt><span class="p-feature__mask">Over 700 Islands</span></dt>
                  <dd class="u-fade">
                    <p>There are hundreds of islands scattered across the vast, glittering expanse of the Seto Inland Sea. They rise from the serene, mirror-like sea waters, emerging from the mist as though in an ink painting. The breathtaking beauty of the Setouchi region led to its designation as Japan’s first National Park.</p>
                  </dd>
                </dl>
              </scroll-animation-unit>
      
              <scroll-animation-unit class="p-feature">
                <color-overlay class="p-feature__image" :scale="true">
                  <img src="../assets/img/about/region.jpg" alt="" class="u-cover">
                  <img src="../assets/img/about/region.jpg" alt="" class="u-cover p-feature__grayImage">
                </color-overlay>
                <dl class="p-feature__description">
                  <dt><span class="p-feature__mask">A mountainous region</span></dt>
                  <dd class="u-fade">
                    <p>A short drive from the Inland Sea coast transports you to another world entirely - the lushly forested, rugged mountain ranges of the Setouchi region.</p>
                  </dd>
                </dl>
              </scroll-animation-unit>
      
              <scroll-animation-unit class="p-feature" data-flipped>
                <color-overlay class="p-feature__image" :scale="true">
                  <img src="../assets/img/about/wealth.jpg" alt="" class="u-cover">
                  <img src="../assets/img/about/wealth.jpg" alt="" class="u-cover p-feature__grayImage">
                </color-overlay>
                <dl class="p-feature__description">
                  <dt><span class="p-feature__mask">A wealth of <br v-show="!isMobile">Historic Cultural Properties</span></dt>
                  <dd class="u-fade">
                    <p>The ancient Silk Road, a tangle of trade routes through Asia, had at its easternmost extent the Inland Sea. Even today, there is much in the way of art, architecture, history, and culture to experience in the Setouchi region – a testament to its long, vivid history of land and maritime trade.</p>
                  </dd>
                </dl>
              </scroll-animation-unit>
            </div>
          </div>
        </section>
      </scroll-spy-section>

      <scroll-spy-section :label="`About accommodation`">
        <section class="p-about">
          <color-overlay class="p-about__header">
            <h3 class="p-about__heading"><span class="p-about__mask">About accommodation</span></h3>
            <div class="p-about__visual js-navigation-switch">
              <div class="p-about__parallax js-rellax">
                <img src="../assets/img/about/section_4.jpg" alt="" class="u-cover">
              </div>
            </div>
          </color-overlay>
          <div class="p-about__body">
            <scroll-animation-unit 
              class="p-about__section">
              <p class="p-about__paragraph u-fade">Setouchi Cominca Stays offers a unique collection of elegant, traditional Japanese properties available for whole-house rental. With each building anywhere from 100 to 250 years, we preserve their integrity, style and structure while updating them to suit the discerning, modern traveller.</p>
            </scroll-animation-unit>
      
            <scroll-animation-unit class="p-feature" data-flipped data-type="facilities">
              <color-overlay class="p-feature__image" :scale="true">
                <img src="../assets/img/about/facility.jpg" alt="" class="u-cover">
                <img src="../assets/img/about/facility.jpg" alt="" class="u-cover p-feature__grayImage">
              </color-overlay>
      
              <dl class="p-feature__description">
                <dt><span class="p-feature__mask">Facilities</span></dt>
                <dd class="u-fade">
                  <p>Each Cominca residence represents a gorgeous fusion of modern and traditional Japanese design, and is outfitted with luxurious furnishings and amenities fit for the discerning, modern traveller.</p>
                  <p>Each residence features several rooms, including a private garden.</p>
                </dd>
              </dl>
            </scroll-animation-unit>
      
            <scroll-animation-unit class="p-container p-about__facilities">
              <ul class="p-facilitiesList u-fade">
                <li>
                  <div class="c-facilityAccordion">
                    <div class="c-facilityAccordion__trigger" @click.prevent="onClickTrigger">Living room</div>
                    <div class="c-facilityAccordion__container">
                      <div class="c-facilityAccordion__content">
                        <div class="c-facilityAccordion__icon">
                          <img src="../assets/img/about/living.svg" alt="">
                        </div>
                        <p>Our living rooms blend Western-style seating with chic Japanese design elements. A perfect place to kick back and relax after a long day of exploring.</p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="c-facilityAccordion">
                    <div class="c-facilityAccordion__trigger" @click.prevent="onClickTrigger">Bedroom</div>
                    <div class="c-facilityAccordion__container">
                      <div class="c-facilityAccordion__content">
                        <div class="c-facilityAccordion__icon">
                          <img src="../assets/img/about/bed.svg" alt="">
                        </div>
                        <p>Sleep is important when you’re traveling. Our residences have ultra-comfortable, quality beds and Futon mattress for a good night’s rest.</p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="c-facilityAccordion">
                    <div class="c-facilityAccordion__trigger" @click.prevent="onClickTrigger">Bathroom</div>
                    <div class="c-facilityAccordion__container">
                      <div class="c-facilityAccordion__content">
                        <div class="c-facilityAccordion__icon">
                          <img src="../assets/img/about/bath.svg" alt="">
                        </div>
                        <p>Each residence features luxurious, modern Japanese-style bathrooms with a shower and bath. Soothe your aching muscles in the soaking tub next to the shower.</p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="c-facilityAccordion">
                    <div class="c-facilityAccordion__trigger" @click.prevent="onClickTrigger">Kitchen</div>
                    <div class="c-facilityAccordion__container">
                      <div class="c-facilityAccordion__content">
                        <div class="c-facilityAccordion__icon">
                          <img src="../assets/img/about/kitchen.svg" alt="">
                        </div>
                        <p>All properties have a full-scale kitchen with a well-stocked pantry and all the equipment you’ll need for cooking and dining in. Perfect for an extended escape from the city. </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="c-facilityAccordion">
                    <div class="c-facilityAccordion__trigger" @click.prevent="onClickTrigger">Toilet</div>
                    <div class="c-facilityAccordion__container">
                      <div class="c-facilityAccordion__content">
                        <div class="c-facilityAccordion__icon">
                          <img src="../assets/img/about/toilet.svg" alt="">
                        </div>
                        <p>Our residences are outfitted with modern, fully-automated Japanese washlet-style toilets – a necessity for a comfortable vacation.</p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="c-facilityAccordion">
                    <div class="c-facilityAccordion__trigger" @click.prevent="onClickTrigger">Complete air conditioning</div>
                    <div class="c-facilityAccordion__container">
                      <div class="c-facilityAccordion__content">
                        <div class="c-facilityAccordion__icon">
                          <img src="../assets/img/about/air_conditioning.svg" alt="">
                        </div>
                        <p>With dual air-conditioning and heating in all rooms, you’ll never have to worry about the temperature indoors, no matter the season.</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
      
      
      
      
              <ul class="p-facilities">
                <li class="u-fade">
                  <div class="c-facility">
                    <picture class="c-facility__image">
                      <img src="../assets/img/about/living.svg" alt="">
                    </picture>
                    <dl class="c-facility__description">
                      <dt style="font-weight: 400;">Living room</dt>
                      <dd>Our living rooms blend Western-style seating with chic Japanese design elements. A perfect place to kick back and relax after a long day of exploring.</dd>
                    </dl>
                  </div>
                </li>
                <li class="u-fade">
                  <div class="c-facility">
                    <div class="c-facility__image">
                      <img src="../assets/img/about/bed.svg" alt="">
                    </div>
                    <dl class="c-facility__description">
                      <dt>Bedroom</dt>
                      <dd>Sleep is important when you’re traveling. Our residences have ultra-comfortable, quality beds and Futon mattress for a good night’s rest.</dd>
                    </dl>
                  </div>
                </li>
                <li class="u-fade">
                  <div class="c-facility">
                    <picture class="c-facility__image">
                      <img src="../assets/img/about/bath.svg" alt="">
                    </picture>
                    <dl class="c-facility__description">
                      <dt>Bathroom</dt>
                      <dd>Each residence features luxurious, modern Japanese-style bathrooms with a shower and bath. Soothe your aching muscles in the soaking tub next to the shower.</dd>
                    </dl>
                  </div>
                </li>
                <li class="u-fade">
                  <div class="c-facility">
                    <picture class="c-facility__image">
                      <img src="../assets/img/about/kitchen.svg" alt="" data-type="kitchen">
                    </picture>
                    <dl class="c-facility__description">
                      <dt>Kitchen</dt>
                      <dd>All properties have a full-scale kitchen with a well-stocked pantry and all the equipment you’ll need for cooking and dining in. Perfect for an extended escape from the city. </dd>
                    </dl>
                  </div>
                </li>
                <li class="u-fade">
                  <div class="c-facility">
                    <picture class="c-facility__image">
                      <img src="../assets/img/about/toilet.svg" alt="">
                    </picture>
                    <dl class="c-facility__description">
                      <dt>Toilet</dt>
                      <dd>Our residences are outfitted with modern, fully-automated Japanese washlet-style toilets – a necessity for a comfortable vacation.</dd>
                    </dl>
                  </div>
                </li>
                <li class="u-fade">
                  <div class="c-facility">
                    <picture class="c-facility__image">
                      <img src="../assets/img/about/air_conditioning.svg" alt="">
                    </picture>
                    <dl class="c-facility__description">
                      <dt>Complete air <br>conditioning</dt>
                      <dd>With dual air-conditioning and heating in all rooms, you’ll never have to worry about the temperature indoors, no matter the season.</dd>
                    </dl>
                  </div>
                </li>
              </ul>
            </scroll-animation-unit>
      
            <!-- <scroll-animation-unit class="p-feature">
              <color-overlay class="p-feature__image" :scale="true">
                <img src="../assets/img/about/activity.jpg" alt="" class="u-cover">
                <img src="../assets/img/about/activity.jpg" alt="" class="u-cover p-feature__grayImage">
              </color-overlay>
              <dl class="p-feature__description">
                <dt><span class="p-feature__mask">Activity</span></dt>
                <dd class="u-fade">
                  <p>Enjoy an extended stay at one of our Cominca residences, and use them as a base for day trips and sightseeing throughout the Setouchi region. Discover natural wonders right at your doorstep. Dive deep into local history and culture. Taste the finest regional cuisine and wash it down with local sake. The secrets of the Setouchi region await.</p>
                </dd>
              </dl>
            </scroll-animation-unit> -->
          </div>
        </section>
      </scroll-spy-section>
      
      <scroll-spy-section :label="`About Cominca`">
        <section class="p-about">
          <color-overlay class="p-about__header">
            <h3 class="p-about__heading"><span class="p-about__mask">About Cominca</span></h3>
            <div class="p-about__visual js-navigation-switch">
              <div class="p-about__parallax js-rellax">
                <img src="../assets/img/about/section_2.jpg" alt="" class="u-cover">
              </div>
            </div>
          </color-overlay>
          <div class="p-about__body">
            <section class="p-about__section">
              <scroll-animation-unit 
                class="p-about__whatIs">
                <h4 class="p-about__subheading u-fade">Castles and temples tend to hog the limelight in quest for saving heritage sites, but no less worthy of preservation are the beautiful cominca buildings - relics of Japanese folk culture and rapidly disappearing ways of rural life.  </h4>
                <div>
                  <p class="u-fade">Literally meaning ‘old house,’ ‘Cominca’ are houses built using time-honoured, traditional Japanese architectural techniques. A medley of materials - such as wood, earth, rocks, ceramics, plant fibers, and paper - goes into the construction of these houses. The design of the Cominca, too, reflects a wonderfully Japanese aesthetic sensibility in all aspects from its exterior to the furnishings. </p>
                  <p class="u-fade">Though no two Cominca buildings are identical, many are beautiful in a slightly spare, minimalist way, with much thought given to visual contrasts in their design. For instance, on the engawa, a wooden porch-like corridor bordering the rooms of the Cominca, one might see sunlight streaming in through the open side of the house. The bright light meets the darkness of the interior, and the shadows cast by the deep eaves of the roof - a delightful play of light and shadow in this transitional space between the outside and inside. One might even call this an expression of the Zen spirit.</p>
                </div>
              </scroll-animation-unit>
            </section>
          </div>
        </section>
      </scroll-spy-section>
      
      <scroll-spy-section :label="`The Comachi Project`">
        <section class="p-about">
          <color-overlay class="p-about__header">
            <h3 class="p-about__heading"><span class="p-about__mask">The Comachi Project</span></h3>
            <div class="p-about__visual js-navigation-switch">
              <div class="p-about__parallax js-rellax">
                <img src="../assets/img/about/section_3.jpg" alt="" class="u-cover">
              </div>
            </div>
          </color-overlay>
          <div class="p-about__body">
            <scroll-animation-unit 
              class="p-about__text">
              <p class="p-about__lead u-fade">The Setouchi Comachi Project is a social business venture with a strong ethos towards sustainable tourism. Over the next few years, we aim to remodel Cominca buildings throughout the Setouchi region, turning these culturally significant properties into unique lodgings for visitors to Japan.<br>
                <br>
              The project has three primary goals:</p>
            </scroll-animation-unit>
              
              
            <div class="p-about__projects">
              <ul class="p-projects">
                <li v-for="(project, i) in projects">
                  <scroll-animation-unit 
                    class="p-project" 
                    :data-even="(i + 1) % 2 === 0">
                    <dl class="p-project__description">
                      <dt><span class="u-mask" v-html="project.name"></span></dt>
                      <dd class="u-fade">
                        <p><em v-html="project.emphasized"></em></p>
                        <p v-html="project.text"></p>
                      </dd>
                    </dl>
                  </scroll-animation-unit>
                </li>
              </ul>
            </div>
            
            <scroll-animation-unit 
              class="p-about__text" 
              data-type="figure">
              <p class="p-about__lead u-fade">Through staying in off-the-beaten-track areas of the Setouchi region, we hope that visitors will find a sense of ‘real Japan’ in the heart of the countryside. Our Cominca are the perfect starting point for authentic and fulfilling travel experiences in the Setouchi region. </p>
            </scroll-animation-unit>
            
            <scroll-animation-unit>
              <div class="p-about__vennDiagram u-fade">
                <venn-diagram />  
              </div>
            </scroll-animation-unit>
          </div>
        </section>
      </scroll-spy-section>
      
      
    </scroll-spy>
    
    <page-navigation 
      :sections="sections" 
      :class="{
        'is-brighten': isNavigationBrighten
      }"/>
  </section>
</template>

<script>
  import { mapMutations } from 'vuex'

  import Rellax from 'rellax'


  import PageNavigation from '~/partial/page-navigation'
  import vennDiagram from '~/partial/venn-diagram'

  import navigationSwitch from '~/mixins/navigation-switch'
  import objectFitCover from '~/mixins/object-fit-cover'
  import imageLoader from '~/mixins/image-loader'

  import about from '~/data/about'


  import 'rgbaster'

  export default {
    name: 'page-about',
    mixins: [
      navigationSwitch,
      objectFitCover,
      imageLoader,
    ],
    components: {
      PageNavigation,
      vennDiagram,
    },
    data () {
      return {
        rellax: null,
        projects: [],
        facilities: [],
        sections: []
      }
    },
    computed: {
      isMobile() {
        return this.$window.viewport === 'mobile'
      },
      eyecatchHeight() {
        return this.isMobile ? `${global.innerHeight}px` : '100vh'
      }
    },
    watch: {
      isMobile() {
        // PC, SP でparallaxの移動量が異なるため再作成する
        this.destroyParallax()

        this.$nextTick(() => {
          this.initializeParallax()  
        })
      },
    },
    beforeRouteLeave(to, from, next) {
      this.showLoader()

      next()
    },
    created() {
      this.projects = about.projects
      this.facilities = about.facilities
    },
    mounted() {
      this.$nextTick(() => {
        this.$_imageLoader_load(this.$el).then(this.onImagesLoaded)
      })
    },
    beforeDestroy() {
      this.destroyParallax()
    },
    methods: {
      initializeParallax() {
        // eslint-disable-next-line no-new
        this.rellax = new Rellax('.js-rellax', {
          center: true,
          speed: this.isMobile ? -0.4 : -2
        })
      },

      destroyParallax() {
        this.rellax && this.rellax.destroy()
      },

      onImagesLoaded() {
        if(!this.isMobile) {
          this.initializeParallax()
        }

        this.$_navigationSwitch_setTriggers('.js-navigation-switch')

        this.$refs.heading.classList.add('is-animated')

        
        this.$refs.scrollSpy.watch()
        this.sections = this.$refs.scrollSpy.getLabels()

        this.hideLoader()
      },

      onClickTrigger(e) {
        // アコーディオンの開閉
        // TODO: 時間があったら書き直すべき
        let trigger = e.currentTarget
        let container = trigger.parentNode.querySelector('.c-facilityAccordion__container')
        let content = trigger.parentNode.querySelector('.c-facilityAccordion__content')

        trigger.classList.toggle('is-active')

        container.style.height = trigger.classList.contains('is-active') ? `${content.clientHeight}px` : '0'
      },
      ...mapMutations({
        'showLoader': 'loader/SHOW',
        'hideLoader': 'loader/HIDE',
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/about.vue